

















import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import BookmarkMixin from './BookmarkMixin';
import { EnterpriseFormTableBookmarkColumn } from '../../../../store/models/EnterpriseForm/EnterpriseFormTableBookmarkColumn';
import IntegerBookmark from './IntegerBookmark.vue';
import StringBookmark from './StringBookmark.vue';
import KeyboardTimeBookmark from './KeyboardTimeBookmark.vue';
import UserCreatedListBookmark from './UserCreatedListBookmark.vue';
import CustomQueryListBookmark from './CustomQueryListBookmark.vue';
import CompanyListBookmark from './CompanyListBookmark.vue';
import DynamicListBookmark from './DynamicListBookmark.vue';
import FileBookmark from './FileBookmark.vue';
import CurrencyBookmark from './CurrencyBookmark.vue';
import TableRowContainer from '@/components/Cartable/EnterpriseForm/EnterpriseFormContainer/TableRowContainer.vue';
import * as $ from 'jquery';
import { ValidValuesForSingleTable } from '../../../../store/models/EnterpriseForm/EnterpriseFormValidValues';
import FormFormatRow from '@/components/Cartable/EnterpriseForm/EnterpriseFormContainer/FormFormatRow/FormFormatRow.vue';
import store from '@/store';
import BooleanBookmark from './BooleanBookmark.vue';
import DataBookmark from './DateBookmark.vue';
import FloatBookmark from './FloatBookmark.vue';
@Component
export default  class  TableBookmark extends Mixins(BookmarkMixin){
    @Prop() maxColumnLabelWidth?: number;
    @Prop() validValues?: ValidValuesForSingleTable;
    shallShowAddNew = false;
    created(){
        //console.log("Table row created");
        //console.log(this);
        this.rowsCount = 0;
        this.value = '';
        if(!this.bookmark)return;
        if(!this.bookmark.tableColumns)return;
        
        
        
        if(this.canAddNewRow){
            this.shallShowAddNew=true;
        }else{
            this.shallShowAddNew=false;
        }
        store.state.eventHub.$on("tabledata-set-request",this.onTableDataSet);
        //console.log("Add event" + (this as any)._uid);
        store.state.eventHub.$on("tablerow-add-requested",this.onTableRowAddRequested);
    }
    formatCells =  [] as any[];
    formatRow(rowContainerInstance: any){
        if(!this.bookmark)return;
        const columnFormat = this.getColumnFormat();
        const rows =  columnFormat.split(',');
        this.formatCells = [];
        const FormFormatRowClass = Vue.extend(FormFormatRow);
        for(let i = 0; i< rows.length; i++){
            const prop = {rowIndex: i, columnCount: parseInt(rows[i])};
            const formatRowInstance = new FormFormatRowClass({propsData: prop});
            formatRowInstance.$mount();
            this.formatCells.push(formatRowInstance);
            (rowContainerInstance.$refs.tablerow as any).appendChild(formatRowInstance.$el);
        }
    }
    rows =  [] as TableRowContainer[];
    addRow(shallEmitPropertyChanged?: boolean){
        if(!this.bookmark)return;
        if(!this.bookmark.tableColumns)return;
        console.log("Add row");
        this.rowsCount++;
        const rowContainerClass = Vue.extend(TableRowContainer);
        //console.log("Row added" + (this as any)._uid  + shallEmitPropertyChanged);
        const rowContainerInstance = new rowContainerClass({propsData: {rowIndex:this.rowsCount-1,tableName: this.englishName} });
        this.rows.push(rowContainerInstance as TableRowContainer);
        rowContainerInstance.$mount();
        this.formatRow(rowContainerInstance);
        let visibleIndex = 0;
        this.bookmark.tableColumns.forEach((columnBookmark,index)=>{
            if(columnBookmark){
                const col = this.getCol(visibleIndex);
                if(columnBookmark.isVisible)
                    visibleIndex++
                const formatRowIndex = col.rowIndex;
                const columnComponent = this.getColumnBookmarkComponent(columnBookmark);
                if(columnComponent){
                    if(this.formatCells[formatRowIndex])
                        this.formatCells[formatRowIndex].$refs[col.colName][0].appendChild(columnComponent);
                }
            }
        });
        if((this.$refs.tablecontainer as any))
            (this.$refs.tablecontainer as any).appendChild(rowContainerInstance.$el);
        let shall =  false;
        if(shallEmitPropertyChanged==null){
            shall = true;
        }else{
            shall = shallEmitPropertyChanged; 
        }
        if(shall){
            this.$emit("value-changed",this.englishName);
        }
    }
    onTableRowAddRequested(info: any){
        //console.log("infoId===> " + info.uid );
        //if(info.uid != (this as any)._uid)return;
        if(info.tableName != this.englishName)return;
        let isAnyRowAdded=false;
        //console.log("info id=>" + info.uid + "   " + "this id==>" + (this as any)._uid);
        //console.log("this.RowCount=>" + this.rowsCount);
        //console.log("row count => " + info.rowCount);
        for(let i=0;i<info.rowCount;i++){
            isAnyRowAdded = true;
            console.log("Request");
            this.addRow(false);
        }
        if(isAnyRowAdded){
            this.$emit("value-changed",this.englishName);
        }
    }
    
    getColumnBookmarkComponent(columnBookmark: EnterpriseFormTableBookmarkColumn){
        let componentClass = undefined;
        const props = {} as any;
        props.tableColumnBookmark = columnBookmark;
        props.parentTableName = this.englishName;
        props.tableRowIndex = this.rowsCount -1;
        props.isVisible = columnBookmark.isVisible;
        switch(columnBookmark.type){
            case 0:
                componentClass = Vue.extend(IntegerBookmark);
                break;
            case 1:
                componentClass = Vue.extend(StringBookmark);
                break;
            case 2:
                componentClass = Vue.extend(BooleanBookmark);
                break;
            case 3:
                componentClass = Vue.extend(FloatBookmark);
                break;
            case 4: 
                componentClass = Vue.extend(CurrencyBookmark);
                break;
            case 5: 
                componentClass = Vue.extend(DataBookmark);
                break;
            case 6:
                componentClass = Vue.extend(KeyboardTimeBookmark);
                break;
            case 7:
                componentClass = Vue.extend(UserCreatedListBookmark);
                break;
            case 9:
                
                componentClass = Vue.extend(CustomQueryListBookmark);
                if(this.validValues){
                    const currentColumnValues =  this.validValues.columnsValidValues.find(c=>c.columnName === columnBookmark.englishName);
                    if(currentColumnValues)
                        props.validValues = currentColumnValues.validValues;
                }
                break;
            case 10:
                componentClass = Vue.extend(CompanyListBookmark);
                break;
            case 13:
                componentClass = Vue.extend(CustomQueryListBookmark);
                if(this.validValues){
                    const currentColumnValues =  this.validValues.columnsValidValues.find(c=>c.columnName === columnBookmark.englishName);
                    if(currentColumnValues)
                        props.validValues = currentColumnValues.validValues;
                }
                break;
            case 14://dynamicList
                componentClass = Vue.extend(DynamicListBookmark);
                break;
            case 15:
                componentClass = Vue.extend(KeyboardTimeBookmark);
                break;
            case 16:
                componentClass = Vue.extend(FileBookmark);
                break;
        }
        if(componentClass){
            if(this.maxColumnLabelWidth)
                props.maxLabelWidth = this.maxColumnLabelWidth;
            const instance = new componentClass({propsData: props});
            instance.$on("value-changed",(e: any)=>{this.$emit("value-changed",this.englishName)});
            instance.$mount();
            return instance.$el;
        }
        return undefined;
    }
    getData(eventArg: any){
        if(eventArg.tableName !='')return;//answer only requests from form.prevent recursive calls
        if(!this.bookmark)return;
        const obj = {} as any;
        const array  = [] as any;
        for(let i =0; i<this.rowsCount;i++)
        {
            const internalObj = {} as any;
            

            array.push(internalObj);
        }
        obj.tableData = array;
        obj.tableName  = this.bookmark.englishName;
        store.state.eventHub.$emit('form-values-requested',obj);
        eventArg[this.bookmark.englishName] = obj.tableData;
    }

    onTableDataSet(arg: any){
        const tablesData = arg.tablesData;
        const isFromBehindCode = arg.isFromBehindCode;
        
        if(!this.bookmark)return;
        const data = tablesData[this.bookmark.englishName];
        if(!data)return;
        if(data.length != this.rowsCount)
        {
            const info = {} as any;
            const rowCount =   data.length - this.rowsCount;
            info.rowCount = rowCount;
            info.tableName = this.englishName;
            if(rowCount >0){
                console.log("This ugly condition....");
                this.onTableRowAddRequested(info);
            }
            // else if(rowCount < 0){
            //     const abs = Math.abs(rowCount);
            //     for(let i = 0; i< abs; i++){
            //         if(this.rows[this.rows.length -1]){
            //             console.log("Manually removing row");
            //             this.rows[this.rows.length -1].removeRow();
            //             this.rows.pop();
            //             //console.log("Pop command");
            //         }
            //     }
            // }
            //alert("test");
        }
        this.setData(data,isFromBehindCode)
    }

    setData(tableData: any[],isFromBehindCode: boolean){
        tableData.forEach((row,index) => {
            const rowData = {} as any;
            rowData.rowIndex = index;
            rowData.data = row;
            rowData.tableName = this.englishName;
            const obj = {} as any;
            
            
            store.state.eventHub.$emit("tablerow-set-requested",rowData,isFromBehindCode);
        });
    }

    getCol(index: number){
        const result = {} as any;
        result.colName = "";
        result.rowIndex = 0;
        if(!this.bookmark)return result;
        const order = index +1;
        const columnFormat = this.getColumnFormat();
        const rows =  columnFormat.split(',');
        let rowIndex = 0;
        let colIndex = 1;
        let total = 0;
        while(total < index){
            total++;
            
            if(parseInt(rows[rowIndex])=== colIndex){
                rowIndex++;
                colIndex =0;
            }
            colIndex++;
        }
        result.colName =  `col${rowIndex}${colIndex}`;
        result.rowIndex = rowIndex;
        return result;
    }
    getColumnFormat(){
        if(!this.bookmark)return '';
        if(!this.bookmark.tableColumns)return '';
        if(this.bookmark.columnFormat != undefined && this.bookmark.columnFormat != ""){
            const visibleBookmarks =  this.bookmark.tableColumns.filter(bm=>bm.isVisible); 
            const splited =  this.bookmark.columnFormat.split(',');
            let columnFormatSum = 0;
            splited.forEach(x=>{ columnFormatSum += parseInt(x)});
            if(visibleBookmarks.length > columnFormatSum)
            {
                const diff = visibleBookmarks.length - columnFormatSum;
                let result = this.bookmark.columnFormat;
                for(let i =0; i < diff;i++)
                {
                    result += ',1'; 
                }
                return result;
            }
            else{

                return this.bookmark.columnFormat;
            }
        }
        let result = "";
        
        for(let i = 0;i<this.bookmark.tableColumns.length; i++){
            if(this.bookmark.tableColumns[i].isVisible)
            {
                if(result != "") result = result + ",1";
                else result = result + "1";
            }
        }
        return result;



        
    }

    onTableRowRemoved(rowInfo: any){
        if(this.englishName !== rowInfo.tableName)return;
        //این باید فعال شود فعلا در جای دیگری پاپ کردم ولی باید اینجا باشد
        //this.rows =  this.rows.splice(rowInfo.rowIndex,1);
        this.rowsCount--;
    }

    beforeDestroy(){

        //console.log("off event");
        store.state.eventHub.$off("tablerow-add-requested",this.onTableRowAddRequested);
        store.state.eventHub.$off("tabledata-set-request",this.onTableDataSet);

    }
    getColumnType(columnName: string){
        if(!this.bookmark)return 1;
        if(!this.bookmark.tableColumns)return 1;
        const column =  this.bookmark.tableColumns.find(x=>x.englishName === columnName);
        if(column)
            return column.type;
        return 1;
    }
}
